<template>
  <div id="app">
    <TheNavigation :key="$route.fullPath"></TheNavigation>
    <div class="container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import TheNavigation from './components/TheNavigation'
export default {
  name: 'App',
  components: {
    TheNavigation
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue